import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined'
import { styled } from '@mui/material'

export const StyledRoomOutlinedIcon = styled(RoomOutlinedIcon)({
  fontSize: 50,
  color: '#3850B2',
  transform: 'translate(-50%, -90%)',
})
